import PolicyEducationAccount from "views/PolicyEducationAccount";
import Configuration from "views/configuration/Configuration";
import ManagePolicies from "../views/policies/ManagePolicies";
import EuGeneralPurposeStatistics from "views/EuGeneralPurposeStatistics";
import DemandAnalytics from "views/demand/analytics/DemandAnalytics"
import DemandForecasting from "views/demand/forecasting/DemandForecasting"
import SupplyAnalytics from "views/supply/analytics/SupplyAnalytics"
import SupplyForecasting from "views/supply/forecasting/SupplyForecasting"
import TaxonomyManagement from "views/taxonomies/TaxonomyManagement";
import FutureTechnologyTrends from "views/policies/FutureTechnologyTrends";
import ProgramAndNeeds from "views/policies/ProgramAndNeeds";
import GenerateReport from "views/policies/GenerateReport";
import EducationManagement from "views/education/EducationManagement";
import { ProjectorAnalytics } from "views/supply/projector/ProjectorAnalytics";

var routes = [
  {
    path: "/account",
    name: "My Policies",
    icon: "nc-icon nc-single-02",
    component: <PolicyEducationAccount />,
    layout: "/policy-education",
  },
  {
    path: "/account/manage-policies",
    name: "Manage Policies",
    icon: "nc-icon nc-single-02",
    component: <ManagePolicies />,
    layout: "/policy-education",
  },
  {
    path: "/account/manage-universities",
    name: "Manage Universities",
    icon: "nc-icon nc-single-02",
    component: <EducationManagement />,
    layout: "/policy-education",
  },
  {
    path: "/account/taxonomy",
    name: "Taxonomy",
    icon: "nc-icon nc-single-02",
    component: <TaxonomyManagement />,
    layout: "/policy-education",
  },
  {
    path: "/account/program-and-needs",
    name: "Program and Needs",
    icon: "nc-icon nc-single-02",
    component: <ProgramAndNeeds />,
    layout: "/policy-education",
  },
  {
    path: "/account/future-technology-trends",
    name: "Future Technology Trends",
    icon: "nc-icon nc-single-02",
    component: <FutureTechnologyTrends />,
    layout: "/policy-education",
  },
  {
    path: "/account/generate-report",
    name: "Generate Report",
    icon: "nc-icon nc-single-02",
    component: <GenerateReport />,
    layout: "/policy-education",
  },
  {
    name: "Demand",
    isCategory: true, 
    children: [
      {
        path: "/demand-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <DemandAnalytics />,
        layout: "/policy-education",
      },
      {
        path: "/demand-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <DemandForecasting />,
        layout: "/policy-education",
      },
      {
        path: "/projector-analytics",
        name: "Projector",
        icon: "nc-icon nc-map-big",
        component: <ProjectorAnalytics />,
        layout: "/policy-education",
      },
    ],
  },
  {
    name: "Supply",
    isCategory: true,
    children: [
      {
        path: "/supply-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <SupplyAnalytics />,
        layout: "/policy-education",
      },
      {
        path: "/supply-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <SupplyForecasting />,
        layout: "/policy-education",
      },
    ],
  },
  {
    path: "/configuration",
    name: "Configuration",
    icon: "nc-icon nc-settings",
    component: <Configuration />,
    layout: "/policy-education",
  },
];
export default routes;
